import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Evento } from "../../models/evento";
import { IGetEventosUseCase } from "../../../presentation/useCases/read/get_eventos_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetEventosUseCase
 */

export class GetEventosUseCase extends BasePaginatedUseCase<Evento> implements IGetEventosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getEventos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getEventos(idFuncionario, page, pageSize);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}